import axios from 'axios';

export class ExecutionService {
    http = null;
    baseUrl = 'https://candia-verde.ekapps.gr/api';

    constructor() {
        this.http = axios.create({
            baseURL: this.baseUrl,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    // Get all command executions
    async getCommandExecutions() {
        try {
            const response = await this.http.get('/commandexecutions');
            return response.data;
        } catch (error) {
            console.error('Error fetching command executions:', error);
            return [];
        }
    }

    // Get command execution by ID
    async getCommandExecutionById(id) {
        try {
            const response = await this.http.get(`/commandexecutions/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching command execution:', error);
            return null;
        }
    }

    // Get executions by command ID
    async getCommandExecutionsByCommandId(commandId) {
        try {
            const response = await this.http.get(`/commandexecutions/by-command/${commandId}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching command executions by command ID:', error);
            return [];
        }
    }

    // Start a new command execution
    async startCommandExecution(commandId) {
        try {
            const response = await this.http.post('/commandexecutions/start', {
                commandId: commandId
            });
            return response.data;
        } catch (error) {
            console.error('Error starting command execution:', error);
            throw error;
        }
    }

    // Update command execution (during execution)
    async updateCommandExecution(execution) {
        try {
            const response = await this.http.put(`/commandexecutions/${execution.id}`, {
                id: execution.id,
                status: execution.status,
                currentStep: execution.currentStep,
                ingredients: execution.ingredients || []
            });
            return response.data;
        } catch (error) {
            console.error('Error updating command execution:', error);
            throw error;
        }
    }

    // Complete command execution
    async completeCommandExecution(executionId) {
        try {
            const response = await this.http.post(`/commandexecutions/${executionId}/complete`);
            return response.data;
        } catch (error) {
            console.error('Error completing command execution:', error);
            throw error;
        }
    }

    // Helper method to create ingredient data for execution
    createExecutionIngredient(ingredientId, plannedQuantity, actualQuantity, unit) {
        return {
            ingredientId: ingredientId,
            plannedQuantity: plannedQuantity,
            actualQuantity: actualQuantity,
            unit: unit,
            weighedAt: new Date().toISOString()
        };
    }
}
